define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/heading/AggregateController",
	"csi/locale",
	"csi/xml"
], function(array,declare,lang,Controller,PostRequest,AggregateController,locale,xml) {

	return declare(AggregateController, {
		hasToConfirmAction: function() {
			return true;
		},

		confirmAction: function(/*Object*/params) {
			// summary: issue request as PostRequest so we get return value
			var req = new PostRequest("MaterialSpec", "StyleCanUpdateAllBomProductStructures")
				.addParameter(xml.PROP_URL_PARENT, this.m_urlNode);
			req.post({}).then(lang.hitch(this, this._onValidateResponse), lang.hitch(this, this._onPublishError));
		},

		_onValidateResponse: function(/*Response*/response) {
			if (response.getReturnValue()) {
				// no frozen BOM with a ProductStructure, so proceed w/o confirming
				this.preProcess();
			} else {
				// frozen BOM with a ProductStructure, so confirm partial update
				this._confirm("ProductStructureInUseTitle", "ProductStructureInUsePrompt");
			}
		},

		_confirm: function(titleKey, messageKey) {
			Controller.prototype.confirmAction.call(this, {
				title: locale.resource(titleKey),
				message: locale.resource(messageKey)
			});
		}
	});
});
